import Repository from './Repository';

export default {
  exportMembers(filters) {
      let filter = ('' !== filters.status) ? 'status: "'+filters.status+'"' : ''
      filter += ('' !== filters.type) ? 'type: "'+filters.type+'"' : ''
      let fields = filters.fields.join(',')

      return Repository.post(
        'export/memberships',
        {
          query: `query{
    memberships(`+filter+`){
        `+fields+`
    }
}`
      }
    )
  },

  exportDonations(filters) {
    let filter = ('' !== filters.status) ? 'status: "'+filters.status+'"' : ''
    let fields = filters.fields.join(',')

    return Repository.post(
      'export/donations',
      {
        query: `query{
    donations(`+filter+`){
        `+fields+`
    }
}`
      }
    )
  },
}
